// src/Components/AddFeedSource.js
import { useState } from "react";

function AddFeedSource({ onSourceAdded, onClose }) {
  const [name, setName] = useState("");
  const [url, setUrl] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Styles
  const styles = {
    container: {
      backgroundColor: "#fff3e0",
      borderRadius: "8px",
      padding: "20px",
      marginBottom: "20px",
      boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
      border: "1px solid #ffe0b2",
    },
    title: {
      fontSize: "18px",
      fontWeight: "600",
      color: "#e67e22",
      marginTop: "0",
      marginBottom: "15px",
    },
    form: {
      display: "flex",
      flexDirection: "column",
      gap: "15px",
    },
    input: {
      padding: "10px 12px",
      fontSize: "14px",
      border: "1px solid #ced4da",
      borderRadius: "4px",
      outline: "none",
      transition: "border-color 0.2s",
    },
    button: {
      backgroundColor: "#e67e22",
      color: "white",
      border: "none",
      padding: "10px 16px",
      borderRadius: "4px",
      cursor: "pointer",
      fontWeight: "500",
      fontSize: "14px",
      transition: "background-color 0.2s",
      alignSelf: "flex-start",
    },
    buttonDisabled: {
      backgroundColor: "#bdc3c7",
      cursor: "not-allowed",
    },
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    console.log("Submitting RSS source:", { name, url });

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/rss/api/add-feed-source`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
          body: JSON.stringify({ name, url }),
        }
      );

      console.log("Response status:", response.status);
      console.log("Response ok:", response.ok);

      const data = await response.json();
      console.log("Response data:", data);

      if (!response.ok) {
        throw new Error(data.message || `HTTP error! status: ${response.status}`);
      }

      if (data.success) {
        alert("RSS source added successfully!");
        setName("");
        setUrl("");
        
        // Call parent functions to update the UI
        if (onSourceAdded) {
          onSourceAdded({ name, url, id: data.id });
        }
        if (onClose) {
          onClose();
        }
      } else {
        throw new Error(data.message || "Failed to add RSS source");
      }
    } catch (error) {
      console.error("Error adding RSS source:", error);
      alert(`Failed to add RSS source: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={styles.container} className="rss-add-source">
      <style>{`
        @media (max-width: 1024px) {
          .rss-add-source { padding: 16px; }
        }
        @media (max-width: 768px) {
          .rss-add-source { padding: 14px; }
          .rss-add-source form { gap: 12px; }
          .rss-add-source button { width: 100%; }
        }
        @media (max-width: 480px) {
          .rss-add-source { padding: 12px; }
        }
      `}</style>
      <h2 style={styles.title}>Add New RSS Source</h2>
      <form style={styles.form} onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          disabled={isLoading}
          style={styles.input}
          onFocus={(e) => {
            e.currentTarget.style.borderColor = "#e67e22";
          }}
          onBlur={(e) => {
            e.currentTarget.style.borderColor = "#ced4da";
          }}
        />
        <input
          type="url"
          placeholder="URL (e.g., https://example.com/rss)"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          required
          disabled={isLoading}
          style={styles.input}
          onFocus={(e) => {
            e.currentTarget.style.borderColor = "#e67e22";
          }}
          onBlur={(e) => {
            e.currentTarget.style.borderColor = "#ced4da";
          }}
        />
        <button
          type="submit"
          disabled={isLoading}
          style={{
            ...styles.button,
            ...(isLoading ? styles.buttonDisabled : {}),
          }}
          onMouseOver={(e) => {
            if (!isLoading) {
              e.currentTarget.style.backgroundColor = "#d35400";
            }
          }}
          onMouseOut={(e) => {
            if (!isLoading) {
              e.currentTarget.style.backgroundColor = "#e67e22";
            }
          }}
        >
          {isLoading ? "Adding..." : "Add Source"}
        </button>
      </form>
    </div>
  );
}

export default AddFeedSource;
